import React, { useState } from 'react';
import '../../App.css';
import CSS from 'csstype';
import { useAppSelector } from '../../app/hooks';
import { handleKeyboardActivation } from '../../utils/accessibility';

// images

// classes

//	--------------------------------------------------------------------------
//
//	P R O P E R T I E S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	H T M L   C U S T O M   C O M P O N E N T S
//
//	--------------------------------------------------------------------------

//	--------------------------------------------------------------------------
//
//	C L A S S   D E F I N I T I O N
//
//	--------------------------------------------------------------------------

export default function PanelButton(props: {
  name: string;
  icon?: string;
  iconBW?: string;
  projectName: string;
  description: string;
  onClick: (event: React.MouseEvent<HTMLButtonElement>) => void;
  selected?: boolean;
  focused?: boolean;
  darkBackground?: boolean;
  disabled?: boolean;
}) {
  //
  //	--------------------------------------------------------------------------
  //
  //	R E D U X   S T A T E   H A N D L I N G
  //
  //	--------------------------------------------------------------------------

  const sG_DarkMode: boolean = useAppSelector((state) => state.global.darkMode);

  //	--------------------------------------------------------------------------
  //
  //	D E C L A R A T I O N S
  //
  //	--------------------------------------------------------------------------

  const [sHovered, setHovered] = useState<boolean>(false);

  //	------------------------------------------------------------
  //
  //	F U N C T I O N S
  //
  //	------------------------------------------------------------

  //	------------------------------------------------------------
  //
  //	C O M P O N E N T   C O D E
  //
  //	------------------------------------------------------------

  return (
    <button
      id={props.name}
      title={props.description}
      type="button"
      className="button"
      data-type={props.selected ? (sG_DarkMode ? 'PRIMARY' : 'SECONDARY') : 'NONE'}
      style={{
        flex: '0 0 auto',
        margin: '1px 2px 1px 2px',
        padding: '5px 0px 5px 0px',
      }}
      onClick={props.onClick}
      onMouseOver={() => setHovered(true)}
      onMouseLeave={() => setHovered(false)}
      role="button"
      tabIndex={props.selected || props.focused ? 0 : -1}
      aria-pressed={props.selected === true}
      disabled={props.disabled === true}
    >
      <div
        style={{
          flex: '0 0 37px',
          width: '37px',
          display: 'flex',
          flexDirection: 'row',
          textAlign: 'center',
          alignItems: 'center',
          height: '100%',
          margin: '0px 0px 0px 2px',
        }}
      >
        {props.icon !== '' && props.icon != undefined ? (
          <img
            style={{
              opacity: props.selected === true || sHovered === true ? '1' : '0.7',
              userSelect: 'none',
              border: 'none',
              padding: '3px 3px 3px 3px',
              borderRadius: '5px',
            }}
            src={
              props.selected !== true && props.iconBW !== undefined
                ? props.iconBW
                : props.icon
            }
            role="decoration"
            alt=""
            width="32"
            height="32"
          />
        ) : (
          <div
            className="text-colour"
            data-white={sG_DarkMode === true || props.darkBackground === true ? 'T' : 'F'}
            data-black={
              sG_DarkMode === false && props.darkBackground !== true ? 'T' : 'F'
            }
            style={{
              flex: '0 0 32px',
              height: '32px',
              backgroundColor: 'transparent',
              fontSize: '17pt',
              display: 'flex',
              alignItems: 'center',
              flexDirection: 'column',
              userSelect: 'none',
              borderRadius: '5px',
              border: 'none',
            }}
          >
            {props.projectName.slice(0, 1)}
          </div>
        )}
      </div>
      <div
        style={{
          flex: '1 1 auto',
          height: 'auto',
          display: 'flex',
          textAlign: 'start',
          flexDirection: 'row',
          alignItems: 'center',
        }}
      >
        <div
          className="text-colour"
          data-white={sG_DarkMode === true || props.darkBackground === true ? 'T' : 'F'}
          data-black={sG_DarkMode === false && props.darkBackground !== true ? 'T' : 'F'}
          style={{
            width: '100%',
            fontSize: '10pt',
            userSelect: 'none',
            fontWeight: sHovered && props.selected !== true ? '800' : '400',
          }}
        >
          {props.projectName}
        </div>
      </div>
      <div style={{ flex: '0 0 4px' }} />
    </button>
  );
} // PanelButton
